/* AMTENDENCY — agrupa quantidade e "Adicionar" numa linha só.

   Na referência os três ficam lado a lado (110 + 15 + 296 + 15 + 50 = 486).
   Aqui eles são blocos irmãos do loop da seção, e alinhar por float deixava
   o bloco anterior (o guia de tamanhos) subir para dentro da linha. Agrupar
   num contêiner flex é determinístico e não depende da ordem de cálculo do
   float.

   O `product-info.js` não recria esses blocos na troca de variante, então
   basta montar uma vez — mas o `shopify:section:load` do editor recria a
   seção inteira, e aí a montagem se repete. */
(function () {
  function monta() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    if (info.querySelector('.am-compra')) return;

    var qtd = info.querySelector('.product-form__quantity');
    var botoes = info.querySelector('.product-form__buttons');
    // sem os botões não há linha de compra
    if (!botoes) return;

    var linha = document.createElement('div');
    linha.className = 'am-compra';
    botoes.parentNode.insertBefore(linha, botoes);
    if (qtd) linha.appendChild(qtd);
    linha.appendChild(botoes);
  }

  /* Breadcrumb: no desktop a referência o mantém no topo da coluna de 486px;
     no celular ele sai da coluna e ocupa a largura toda ACIMA da galeria.
     Um é filho do .product__info-container e o outro é filho do .product.grid
     — nenhum `order` de CSS atravessa essa fronteira, então a troca é aqui. */
  var MQ = window.matchMedia('(min-width: 990px)');

  function breadcrumb() {
    var nav = document.querySelector('.template-product .am-breadcrumb');
    if (!nav) return;
    var grade = document.querySelector('.template-product .product.grid');
    var info = document.querySelector('.product__info-container');
    if (!grade || !info) return;

    if (MQ.matches) {
      nav.removeAttribute('data-am-topo');
      if (nav.parentNode !== info) info.insertBefore(nav, info.firstChild);
    } else {
      nav.setAttribute('data-am-topo', '');
      if (nav.parentNode !== grade) grade.insertBefore(nav, grade.firstChild);
    }
  }

  function tudo() {
    monta();
    breadcrumb();
  }

  document.addEventListener('DOMContentLoaded', tudo);
  document.addEventListener('shopify:section:load', tudo);
  MQ.addEventListener('change', breadcrumb);
  if (document.readyState !== 'loading') tudo();
})();
